import createAxios from './api'

const PATH = 'credentialRefs'

export default {

  async createCredentialRef(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}`, req)

    return resp.data
  },

  async listCredentialRefs(q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`, {
      params: {
        q: q?.toString() || '',
        ...pageRequest
      }
    })

    return resp.data
  },

  async updateMyUser(user) {
    const axios = await createAxios()
    await axios.put(`${PATH}/self`, user)
  },

  async updateCredentialRef(id, q) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${id}`, q)
  },

  async getCredentialRef(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)

    return resp.data
  },

  async deleteCredentialRef(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  },

  async getExternalProviders(clientName) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/providers/${clientName}`)

    return resp.data
  }

}
